<main class="content">
  <section class="novedades-shell">
    <header class="novedades-header">
      <h2>Novedades</h2>
    </header>

    <div class="novedades-list-wrap" *ngIf="novedadesPaginadas.length > 0; else sinNovedades">
      <ul class="novedades-cards-list">
        <li *ngFor="let item of novedadesPaginadas" class="novedad-card">
          <!-- Icon box 51x51 -->
          <div class="icon-box" [ngClass]="'icon-' + colorTipo(item.tipo)">
            <!-- Blue check -->
            <svg *ngIf="colorTipo(item.tipo) === 'blue'" viewBox="0 0 51 51" class="card-icon" fill="none" stroke="#0F69C4" stroke-width="3">
              <path d="M40.5 24.12V25.5C40.498 28.735 39.451 31.882 37.514 34.473C35.577 37.063 32.855 38.959 29.753 39.876C26.651 40.793 23.336 40.683 20.302 39.562C17.268 38.441 14.677 36.369 12.916 33.656C11.156 30.942 10.32 27.732 10.533 24.504C10.745 21.277 11.996 18.205 14.097 15.746C16.199 13.287 19.039 11.573 22.194 10.86C25.349 10.147 28.65 10.474 31.605 11.79M40.5 13.5L25.5 28.515L21 24.015" />
            </svg>
            <!-- Green card -->
            <svg *ngIf="colorTipo(item.tipo) === 'green'" viewBox="0 0 51 51" class="card-icon" fill="none" stroke="#2E7D32" stroke-width="3">
              <path d="M9 22.5H42M12 13.5H39C40.657 13.5 42 14.843 42 16.5V34.5C42 36.157 40.657 37.5 39 37.5H12C10.343 37.5 9 36.157 9 34.5V16.5C9 14.843 10.343 13.5 12 13.5Z" />
            </svg>
            <!-- Orange clipboard -->
            <svg *ngIf="colorTipo(item.tipo) === 'orange'" viewBox="0 0 51 51" class="card-icon" fill="none" stroke="#F4511E" stroke-width="3">
              <path d="M31.5 13.5H34.5C35.296 13.5 36.059 13.816 36.621 14.379C37.184 14.941 37.5 15.704 37.5 16.5V37.5C37.5 38.296 37.184 39.059 36.621 39.621C36.059 40.184 35.296 40.5 34.5 40.5H16.5C15.704 40.5 14.941 40.184 14.379 39.621C13.816 39.059 13.5 38.296 13.5 37.5V16.5C13.5 15.704 13.816 14.941 14.379 14.379C14.941 13.816 15.704 13.5 16.5 13.5H19.5M21 10.5H30C30.828 10.5 31.5 11.172 31.5 12V15C31.5 15.828 30.828 16.5 30 16.5H21C20.172 16.5 19.5 15.828 19.5 15V12C19.5 11.172 20.172 10.5 21 10.5Z" />
            </svg>
          </div>

          <!-- Date & Time -->
          <span class="card-date">{{ formatoFecha(item.fecha) }}</span>

          <!-- Title -->
          <h3 class="card-title">{{ item.titulo }}</h3>

          <!-- Description -->
          <p class="card-desc">{{ item.detalle || item.titulo }}</p>

          <!-- Chip / Etiqueta -->
          <div class="card-chip-wrap">
            <span class="chip-tag" [ngClass]="'chip-' + colorTipo(item.tipo)">{{ etiquetaTipo(item) }}</span>
          </div>
        </li>
      </ul>

      <!-- Pagination -->
      <nav class="numeric-pagination" *ngIf="totalPaginas > 1" aria-label="Paginación de novedades">
        <button
          type="button"
          class="page-nav-btn"
          (click)="cambiarPagina(paginaActual - 1)"
          [disabled]="paginaActual === 1"
          aria-label="Página anterior">
          &lt;
        </button>
        <button
          *ngFor="let p of paginasArray"
          type="button"
          class="page-num-btn"
          [class.page-active]="p === paginaActual"
          (click)="cambiarPagina(p)"
          [attr.aria-current]="p === paginaActual ? 'page' : null">
          {{ p }}
        </button>
        <button
          type="button"
          class="page-nav-btn"
          (click)="cambiarPagina(paginaActual + 1)"
          [disabled]="paginaActual === totalPaginas"
          aria-label="Página siguiente">
          &gt;
        </button>
      </nav>
    </div>

    <ng-template #sinNovedades>
      <div class="empty">
        <p>No hay novedades disponibles.</p>
      </div>
    </ng-template>
  </section>
</main>
